import React from 'react';
import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';

const StatsCard = ({ title, value, icon, color = 'primary', subtitle, trend }) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="start">
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4" sx={{ mb: subtitle ? 0.5 : 0 }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
            {trend && (
              <Typography 
                variant="caption" 
                color={trend > 0 ? 'success.main' : trend < 0 ? 'error.main' : 'text.secondary'}
              >
                {trend > 0 ? '+' : ''}{trend}%
              </Typography>
            )}
          </Box>
          {icon && (
            <Box
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: (theme) => alpha(theme.palette[color].main, 0.1),
                color: (theme) => theme.palette[color].main
              }}
            >
              {icon}
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default StatsCard;